import React, { useCallback, useState } from "react";
import * as Scrivito from "scrivito";
import { downloadLink, getProductInfoReportBlob } from "utils";
import { Button } from "components";
import { useAppBaseContext } from "providers";
import { useTranslate } from "hooks";
import { createProductReport } from "api/mutations";
import { useMutation } from "urql";

export const CreateReportPdfButton = Scrivito.connect(
  ({ productData, presentation }) => {
    const translate = useTranslate();
    const [createPdfActive, setCreatePdfActive] = useState(false);
    const [_data, execute] = useMutation(createProductReport);

    const { lang } = useAppBaseContext();

    const handleClick = useCallback(async () => {
      setCreatePdfActive(true);
      const blob = await getProductInfoReportBlob({
        productData,
        setCreatePdfActive,
        getReportCallback: execute,
        lang,
        translate,
      });
      downloadLink(blob.blob, `${presentation}.${blob.type}`);
      setCreatePdfActive(false);
    }, [execute, lang, presentation, productData, translate]);

    return (
      <Button
        data-testid="product-configurator-report-download-test-id"
        onClick={handleClick}
        disabled={createPdfActive}
      >
        {translate("PRODUCT_CONFIGURATOR_REPORT_DOWNLOAD")}
      </Button>
    );
  },
);
